import React, { useEffect, useContext, useState } from 'react';
import TenantService from "../utils/tenantService"

export const TenantContext = React.createContext();

export default function TenantContextProvider({ children, domain, currentTenant }) {

  const [tenantLoaded, setTenantLoaded] = useState(null)

  const state = {
    domain,
    currentTenant
  };

  const setTenant = () => {

    if (!currentTenant) {
      if (window.location.pathname !== '/404' && !tenantLoaded)
        window.location.href = '/404';
    }

    TenantService.applyStyle(currentTenant);
    setTenantLoaded(true)
  }

  useEffect(() => {
    setTenant()
  }, [])


  return tenantLoaded ? <TenantContext.Provider value={{ ...state }}>{children}</TenantContext.Provider> : (<div></div>);

}

export const useTenantContext = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error(
      'useTenantContext cannot be rendered outside the TenantContext.Provider component'
    );
  }
  return {
    currentTenant: context.currentTenant,
    domain: context.domain,
  };
};
